export default __webpack_public_path__ + "static/media/expire_svg.768fcf44.svg";